module.exports = __webpack_public_path__ + "img/promo_emerald.5f7162f4.png";